/**
 * ActivityAudio - Sound effects for activity feedback.
 *
 * Ported from bumblebee ChallengeAudio. Plays victory, failure,
 * star chime, hint, and step-complete sounds.
 * Respects prefers-reduced-motion.
 *
 * @see GitHub Issue #852
 */

const SOUNDS = {
    victory: '/assets/sounds/entertap.wav',
    oops: '/assets/sounds/exittap.wav',
    'star-chime': '/assets/sounds/pop.mp3',
    hint: '/assets/sounds/tap.wav',
    sparkle: '/assets/sounds/tap.wav',
    confetti: '/assets/sounds/entertap.wav'
};

let _prefersReducedMotion = false;

// Check for reduced motion preference
if (typeof window !== 'undefined' && window.matchMedia) {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    _prefersReducedMotion = mq.matches;
    mq.addEventListener('change', (e) => {
        _prefersReducedMotion = e.matches;
    });
}

export default class ActivityAudio {
    /**
     * Play a named sound effect.
     * @param {string} name - Sound name (victory, oops, star-chime, hint, sparkle, confetti)
     */
    static play (name) {
        if (_prefersReducedMotion) return;

        const src = SOUNDS[name];
        if (!src) return;

        try {
            const audio = new Audio(src);
            audio.volume = 0.5;
            audio.play().catch(() => {
                // Swallow autoplay rejection — not critical
            });
        } catch (e) {
            // Audio not available in this environment
        }
    }

    /**
     * Check if reduced motion is preferred.
     * @returns {boolean}
     */
    static get reducedMotion () {
        return _prefersReducedMotion;
    }
}
